import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { Store } from '../../../common/model/Store';
import { EmployeeFacade } from '../../../common/facade/EmployeeFacade';
import { Router } from '@angular/router';
import { Employee } from '../../../common/model/Employee';
import { ModalDirective } from 'ngx-bootstrap/modal';
import {SESSION_STORAGE, WebStorageService} from 'ngx-webstorage-service';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';

@Component({
  selector: 'app-employee-admin',
  templateUrl: './employee-admin.component.html'
})
export class EmployeeAdminComponent implements OnInit {
  titleEmployees = res.Employees;
  lblRegisterEmployee = res.RegisterEmployee;
  lblSearch = res.Search;
  lblEmployeeNumber = res.EmployeeNumber;
  lblName = res.Name;
  lblEmail = res.Email;
  lblStore = res.Store;
  lblEmployeeDetail = res.EmployeeDetail;
  lblClose = res.Close;
  lblSave = res.Save;

  isSpanish = true;
  language = 0

  messagesTable : any = {
    emptyMessage: "",
    totalMessage: "" 
  }

  @ViewChild('createModal') public createModal: ModalDirective;
  loading = false;
  public messageLoader = '';
  // alert
  public alerts = [];
  public rows: Employee[];
  public visibleAdd = false
  public employeeSelected: Employee = new Employee();
  private _filteredData: Employee[];

  constructor(
    private _facade: EmployeeFacade,
    private _router: Router,
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    public strings: Strings
  ) 
  { 

  }

  ngOnInit() {
    this.loading = true;
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1
    }

    this._facade.GetAll().subscribe(result => {
      if (result.completed) {
        this.rows = result.data;
        this._filteredData = result.data;
      }
      this.loading = false;
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger');
      this.loading = false;
    });
    this.validatePermissions()
  }

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();

    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);

    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
        // iterate through each row's column data
        for (let i = 0; i < keys.length; i++) {
            if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                return true;
            }
        }
    });
  }

  onViewDetail(id: number) {
    if(id > 0)
    {
      this.employeeSelected =  this._filteredData.find(x => x.employeeId === id);
    }
    else
    {
      this.employeeSelected = new Employee();
    }

    this.createModal.show();
  }

  validatePermissions()
  {
    let permissionsList = this._storage.get('permissions')

    //validar si cuenta con el permiso para añadir un nuevo puesto
    permissionsList.forEach(element => {
          if (element.name == Permissions.GeneralAccess || element.name == Permissions.ConfigPositionCreate)
      {
        this.visibleAdd = true;
      }
    });
  }
}
